var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-button"},[_c('el-button',{class:_vm.loading?'x-flex x-row-center':'',style:({
    'background-color': _vm.bgc,
    'color':_vm.color ,
    'border':_vm.border,
    'width':_vm.width,
    'height':_vm.height,
    'margin-left':_vm.margin_left,
    'margin-right':_vm.margin_right
  }),attrs:{"loading":_vm.loading,"disabled":_vm.disabled}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28943bb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xButton.vue
// module id = null
// module chunks = 